var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.8334 5.98956L7.81258 14.0104L4.16675 10.3646","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Check.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Check;

Check.default = Check;
